import React, { useEffect } from "react";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const ViewpdfComponent = ({ urlPdf, token, idUser, id, stars, SetProgressUserTaskService, onProgressSent }) => {
    // Crear el plugin sin incluir las miniaturas
    const newplugin = defaultLayoutPlugin();
    
    useEffect(() => {
        const sendProgress = async () => {
          try {
            await SetProgressUserTaskService(
              token,
              idUser,
              id,
              100,
              100,
              stars
            );
            if (onProgressSent) onProgressSent();
          } catch (error) {
            console.error("Error al enviar progreso del PDF:", error);
          }
        };
    
        sendProgress();
      }, [urlPdf]); // Solo cuando cambia el PDF


    return (
        <div className="max-h-[300px] md:max-h-[600px] overflow-y-auto">
            {urlPdf && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <Viewer
                        theme="dark" // Tema oscuro
                        fileUrl={urlPdf}
                        plugins={[newplugin]} // Usamos el plugin sin miniaturas
                    />
                </Worker>
            )}
        </div>
    );
};

export default ViewpdfComponent;
